/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module RightRailModule
 */

import {
    Component,
    Input,
} from '@angular/core';

import './right-rail-vertical-expander.component.less';

/**
 * @description
 *
 *     Component for an vertically expandable list that contains a header and content sub-layers.
 *     An expander can be expanded to display its transcluded children, whether being a list
 *     of text nodes (by working with right-rail-expander-text-child) or other styles of contents.
 *
 * @author Zhiqian Liu
 */
@Component({
    selector: 'right-rail-vertical-expander',
    templateUrl: './right-rail-vertical-expander.component.html',
})
export class RightRailVerticalExpanderComponent {
    /**
     * Leading icon for the header.
     */
    @Input()
    public icon?: string;

    /**
     * Leading solid icon for the header.
     */
    @Input()
    public solid?: boolean = false;

    /**
     * Leading icon color class for the header.
     */
    @Input()
    public color?: string;

    /**
     * Bold header text.
     */
    @Input()
    public headerText: string;

    /**
     * Indicator of whether showing expander children contents.
     */
    @Input()
    public expanded = false;

    /**
     * Provide class as per given condition
     */
    public get classNames(): string {
        if (this.color) {
            return this.color;
        }

        return this.expanded ?
            'right-rail-vertical-expander__header-leading-icon--expanded' : '';
    }

    /**
     * Turn this.expanded to its opposite value to control the expansion state.
     */
    public toggleExpand(): void {
        this.expanded = !this.expanded;
    }
}
